// extracted by mini-css-extract-plugin
export default {"root":"DepositAccount_root__H6gS9","header":"DepositAccount_header__aLUnw","actions":"DepositAccount_actions__bZwbL"};